<template>
  <section class="f-71">
    <div class="f-container">
      <!-- part1 -->
      <div class="map-container" v-ia>
        <div class="map-title f-center-title">地图升级，车道级沉浸导航</div>
        <img
          class="map-item f-select-center border_container_light"
          :src="ImgMap"
          alt="地图升级，车道级沉浸导航"
        />
      </div>
      <!-- part2 -->
      <div class="map-container" v-ia>
        <div class="map-title f-center-title">图层自由定义，地图繁简随心</div>
        <div class="map-item f-select-center border_container_light">
          <div class="map-item-title map-layers-container">
            <img class="map-layers-item" :src="ImgBase" alt="" />
            <!-- 使用绝对定位叠加图层 -->
            <template v-for="(item, index) in controlArr">
              <img
                :key="index"
                v-if="isLayerActive(index + 1)"
                :src="item.image"
                :alt="item.title"
                class="map-layers-item"
              />
            </template>
          </div>
        </div>
        <div class="control-container">
          <div
            v-for="(item, index) in controlArr"
            :key="index"
            class="map71-control-item"
            :class="{ active: isLayerActive(index + 1) }"
            @click="switchImage(index + 1)"
          >
            <img
              :src="
                isLayerActive(index + 1) ? item.activeIcon : item.inactiveIcon
              "
              :alt="item.title"
            />
            <div
              class="control-container-title"
              :class="{ active: isLayerActive(index + 1) }"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <!-- part3 -->
      <div class="map-container" v-ia>
        <div
          class="map-item-traffic f-select-center"
          v-bg
          bg-url="@/v2/auto/assets/image/71/3/1.jpg"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import ImgMap from '@/v2/auto/assets/image/71/1.jpg'
import ImgBase from '@/v2/auto/assets/image/71/2/base.jpg'
import Img2 from '@/v2/auto/assets/image/71/2/site.png'
import Img3 from '@/v2/auto/assets/image/71/2/event.png'
import Img4 from '@/v2/auto/assets/image/71/2/recomand.png'
import Img5 from '@/v2/auto/assets/image/71/2/road.png'
import activeIcon1 from '@/v2/auto/assets/image/71/2/active/1.svg'
import activeIcon2 from '@/v2/auto/assets/image/71/2/active/2.svg'
import activeIcon3 from '@/v2/auto/assets/image/71/2/active/3.svg'
import activeIcon4 from '@/v2/auto/assets/image/71/2/active/4.svg'
import inactiveIcon1 from '@/v2/auto/assets/image/71/2/inactive/1.svg'
import inactiveIcon2 from '@/v2/auto/assets/image/71/2/inactive/2.svg'
import inactiveIcon3 from '@/v2/auto/assets/image/71/2/inactive/3.svg'
import inactiveIcon4 from '@/v2/auto/assets/image/71/2/inactive/4.svg'
export default {
  components: {},
  data() {
    return {
      preload_: true,
      ImgMap: ImgMap,
      activeIndices: [1], // 改为数组，默认选中第一个
      ImgBase,
      controlArr: [
        {
          title: '路况',
          image: Img5,
          activeIcon: activeIcon1,
          inactiveIcon: inactiveIcon1,
        },
        {
          title: '地点',
          image: Img2,
          activeIcon: activeIcon2,
          inactiveIcon: inactiveIcon2,
        },
        {
          title: '事件',
          image: Img3,
          activeIcon: activeIcon3,
          inactiveIcon: inactiveIcon3,
        },
        {
          title: '推荐',
          image: Img4,
          activeIcon: activeIcon4,
          inactiveIcon: inactiveIcon4,
        },
      ],
    }
  },
  mounted() {},
  methods: {
    isLayerActive(index) {
      return this.activeIndices.includes(index)
    },
    switchImage(index) {
      const indexPosition = this.activeIndices.indexOf(index)
      if (indexPosition === -1) {
        // 如果不在选中列表中，添加
        this.activeIndices.push(index)
      } else {
        // 如果已经在选中列表中，移除
        this.activeIndices.splice(indexPosition, 1)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.f-71 {
  margin-top: -100vh;
  width: 100%;
  position: relative;
  background: linear-gradient(155.75deg, #ffffff 42.02%, #f3f4fb 67.94%);
  .f-container {
    position: sticky;
    top: 0;
  }

  .map-container {
    width: 100%;
    padding-bottom: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .map-title {
    font-weight: bold;
    text-align: center;
    margin-bottom: 60px;
    background: radial-gradient(
      146.28% 782.22% at 12.95% -74.31%,
      #0061d8 0%,
      #00d369 100%
    );
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .map-item-traffic {
    height: auto;
    border-radius: 30px;
    aspect-ratio: 2400/1160;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
  }
  .map-item {
    overflow: hidden;
  }

  .map-layers-container {
    position: relative;
    width: 100%;
    height: 100%;
    .map-layers-item {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
    }
  }

  .control-container {
    display: flex;
    gap: 24px;
    margin-top: 30px;
    justify-content: center;
    transition: all 0.3s ease;
    .control-container-title {
      font-size: 14px;
      color: #666;
      display: flex;
      justify-content: center;
      margin-top: 10px;
      &.active {
        color: #0061d8;
        font-weight: 500;
      }
    }
  }

  .control-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    cursor: pointer;
  }
}
</style>
